import { TURNS, TURNS_RANGE, TURNS_TYPE1, TURNS_RANGE_TYPE1, TURNS_TYPE8, TURNS_RANGE_TYPE8 } from '@/const/production/position/tableLimit/turnsLimit'
import { DIAMETER, DIAMETER_RANGE, DIAMETER_TYPE1238, DIAMETER_RANGE_TYPE1238 } from '@/const/production/position/tableLimit/diameterLimit'
import {
  BODY_LENGTH,
  BODY_LENGTH_RANGE,
  BODY_LENGTH_5,
  BODY_LENGTH_RANGE_5,
  WIRE_DIAMETER_TOLERANCE,
  BODY_LENGTH_RANGE_TYPE239,
  BODY_LENGTH_TYPE239,
  BODY_LENGTH_TYPE1,
  BODY_LENGTH_RANGE_TYPE1,
  BODY_LENGTH_DWIRE_SPLIT_VALUE,
  BODY_LENGTH_FOR_S3,
  BODY_LENGTH_RANGE_FOR_S3
} from '@/const/production/position/tableLimit/bodyLengthLimit'
import { TAP_LENGTH, TAP_LENGTH_RANGE } from '@/const/production/position/tableLimit/tapLengthLimit'
import { CLEARANCE_TOLERANCE_RANGE, CLEARANCE_TOLERANCE } from '@/const/production/position/tableLimit/clearanceToleranceLimit'

const POSITION_TABLE_LIMIT = {
  BODY_LENGTH,
  BODY_LENGTH_RANGE,
  BODY_LENGTH_5,
  BODY_LENGTH_RANGE_5,
  BODY_LENGTH_TYPE1,
  BODY_LENGTH_RANGE_TYPE1,
  BODY_LENGTH_DWIRE_SPLIT_VALUE,
  BODY_LENGTH_FOR_S3,
  BODY_LENGTH_RANGE_FOR_S3,
  DIAMETER,
  DIAMETER_RANGE,
  DIAMETER_TYPE1238,
  DIAMETER_RANGE_TYPE1238,
  TAP_LENGTH,
  TAP_LENGTH_RANGE,
  TURNS,
  TURNS_RANGE,
  TURNS_TYPE1,
  TURNS_RANGE_TYPE1,
  TURNS_TYPE8,
  TURNS_RANGE_TYPE8,
  WIRE_DIAMETER_TOLERANCE,
  BODY_LENGTH_RANGE_TYPE239,
  BODY_LENGTH_TYPE239,
  CLEARANCE_TOLERANCE_RANGE,
  CLEARANCE_TOLERANCE
}

export {
  POSITION_TABLE_LIMIT
}
